import { useCallback, useState } from "react";

function useNeedsTruncate() {
  const [needsTruncate, setNeedsTruncate] = useState(null);
  const ref = useCallback((node) => {
    if (node !== null) {
      setNeedsTruncate(node.offsetWidth < node.scrollWidth);
    }
  }, []);
  return [needsTruncate, ref];
}

export default useNeedsTruncate;
